import { WizAuthority } from '@/containers/common'
export default (managerTargetScopeRecord, useTargetScopeRecord) => [
  {
    title: "管理权限",
    name: "managerTargetScopeRecord",
    formItem: {
      type: "diy",
      diy: WizAuthority,
      initialValue: managerTargetScopeRecord,
      keys: ["orgIds", "positionIds", "positionCategoryIds", "personIds"]
    },
  },
  {
    title: "使用权限",
    name: "useTargetScopeRecord",
    formItem: {
      type: "diy",
      diy: WizAuthority,
      initialValue: useTargetScopeRecord,
      keys: ["orgIds", "positionIds", "positionCategoryIds", "personIds"]
    },
  },
];
